<template>
  <div>
    <div id="EntregaDeToken_div" class="w-100 px-5 py-4">
      <div id="TituloEntregaDeToken_div">
        <h1>PANEL DE VIGENCIAS</h1>
        <h3>Control de las vigencias de las audiencias</h3>
      </div>
      <div class="row d-flex">
        <div class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low">
          <div class="area">
            <FiltrosDeBusqueda :catalogos="catalogos" :ejecutaLaFuncion="cargaAudiencias"></FiltrosDeBusqueda>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low">
          <div class="area" v-if="audiencias.length>0">
            <h4>Audiencias encontradas</h4>
            <h6>Modificación / Ampliación de la Vigencia de las Audiencias.</h6>
            <hr />
            <div id="PanelDeAudiencias_table" class="table-responsive">
              <table class="table table-striped table-light table-hover table-sm">
                <thead class="thead-dark">
                  <tr>
                    <th >Fecha y Hora</th>
                    <th >Tipo de Documento</th>
                    <th >Consecutivo</th>
                    <th >Partido Judicial</th>
                    <th >Juzgado</th>
                    <th >Materia</th>
                    <th >Estatus</th>
                    <th ></th>
                  </tr>
                </thead>
                <tbody class="text-dark">
                  <tr v-if="audiencias.length <= 0">
                    <td colspan="8" class="text-center">No existen registros de audiencias</td>
                  </tr>
                  <tr v-else v-for="audiencia in audiencias" :key="audiencia.AudienciaId">
                    <td width ="100" v-html="obtenFechaDeAudienciaConFormato(audiencia.FechaAudiencia)" ></td>
                    <td width ="170">{{audiencia.TipoDocumento.Nombre}}</td>
                    <td width ="90">{{audiencia.Consecutivo}}</td>
                    <td width ="140">{{audiencia.PartidoJudicial.Nombre}}</td>
                    <td>{{audiencia.Area.Nombre}}</td>
                    <td width ="90">{{audiencia.Materia.Nombre}}</td>
                    <td width= "40" v-if="laAudienciaEstaCaducada(audiencia.Vigencia) == true">Caducado</td>
                    <td width= "40" v-else>Vigente</td>
                    <td width= "35" class="text-center">
                      <a v-on:click="preguntarLaNuevaFechaDeVigencia(audiencia.AudienciaId, audiencia.Vigencia)" title="Asignación de la nueva fecha de vencimiento."><i class="fas fa-edit"></i></a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  //Importaciones estandarizadas
  import enumeraciones from '@/../static/js/enumeraciones'
  import sistemas from '@/../static/js/sistemas'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import router from '@/router/index'
  import axios from 'axios'
  import catalogos from '@/../static/js/catalogos'
  import { mapActions } from 'vuex'

  export default {
    components: {
      FiltrosDeBusqueda: sistemas.Forseti.FiltrosDeBusqueda
    },
    data() {
      return {
        enumeraciones,
        catalogos: [
          { catalogoId: enumeraciones.catalogos.Fecha, titulo: "Fecha de vigencia" },
          { catalogoId: enumeraciones.catalogos.PartidosJudiciales, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Consecutivo },
        ],
        audiencias: []
      }
    },
    mounted() {
      //this.cargaAudiencias();
    },
    methods: {
      obtenFechaDeAudienciaConFormato: function(fechaDeAudiencia) {
        return moment(fechaDeAudiencia).format("DD-MM-YYYY</br>h:mm a")
      },
      laAudienciaEstaCaducada: function(fechaDeVigencia) {
        if(moment(fechaDeVigencia).isBefore(moment()))
          return true
        else
          return false;
      },
      cargaAudiencias: function() {
        comun.SeEstaCargandoInformacion(true);

        const parametros = {
          FechaVigencia: this.$store.state.Comun_Fecha,
          PartidoJudicialId: this.$store.state.PJ_Catalogos_009PartidosJudiciales.filtroDeBusqueda_PartidoJudicial,
          MateriaId: this.$store.state.PJ_Catalogos_002Materias.filtroDeBusqueda_Materia,
          AreaId: this.$store.state.PJ_Catalogos_001Areas.filtroDeBusqueda_Area,
          Consecutivo: this.$store.state.Comun_Consecutivo,
          EsPrueba: this.enumeraciones.EsPrueba
        }

        axios.post(
          api.conexion + api.Forseti.sistema.administracion.paneldevigencias.GetAudiencias,
          parametros,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
          ).then(respuesta => {
            if(respuesta.data.SiHayError){
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
              this.audiencias = [];
            } else {
              respuesta.data.Audiencias.forEach(dato => {
                dato.Vigencia = moment(dato.Vigencia).format("YYYY-MM-DD");
              })
              if(respuesta.data.Audiencias.length>0)
              {
                this.audiencias = respuesta.data.Audiencias;
                this.$nextTick(()=> { PaginarTabla('PanelDeAudiencias_table', 10)});
              }
              else
              {
                comun.mensajeDeAlerta("No se encontraron audiencias", null, null);
                this.audiencias = [];
              }
              
            }
  
            comun.SeEstaCargandoInformacion(false);
          }
          ).catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
            this.audiencias = [];
          });
      },
      preguntarLaNuevaFechaDeVigencia(audienciaId, vigencia) {
        bootbox.prompt({
          title: "Mensaje del sistema",
          message: "Elija la nueva fecha de caducidad de la audiencia.<br />Si la audiencia estaba caducada, el sistema procederá a crear todos los procesos para poder descargar la audiencia.<br /><br />",
          inputType: 'date',
          value: vigencia,
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Guarda la fecha de vigencia'
            }
          },
          callback: (respuestaDelBootBox) => {
            if(moment(respuestaDelBootBox, "YYYY-MM-DD", true).isValid()) {
              this.cambiaLaFechaDeLaVigencia(audienciaId, respuestaDelBootBox);
            } else if (respuestaDelBootBox != null) {
              comun.mensajeDeAlerta("Ingrese una fecha correcta para la vigencia.", null, null);
            }
          }
        });
      },
      cambiaLaFechaDeLaVigencia(audienciaId, vigencia) {
        comun.SeEstaCargandoInformacion(true);

        const parametros = {
          Vigencia: vigencia,
          AudienciaId: audienciaId,
          EsPrueba: this.enumeraciones.EsPrueba
        }

        axios.post(
          api.conexion + api.Forseti.sistema.administracion.paneldevigencias.GuardaNuevaVigencia,
          parametros,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
          ).then(respuesta => {
            if(respuesta.data.SiHayError){
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
            } else {
              comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
              this.cargaAudiencias();
            }
  
            comun.SeEstaCargandoInformacion(false);
          }
          ).catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
          });
      }
    }
  }
</script>

<style>
  .padding-div-low {
    padding-top: 40px;
  }

  a {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Forseti/Administracion/PanelDeVigencias/PanelDeAudiencias.vue